module.exports = __webpack_public_path__ + "static/media/5.0a8d107e.jpg";